import type { ProductCard, ProductFields } from './types'

/** Значения карточки в той же форме, что черновик: сравнение «начало правки ↔ 1С сейчас». */
export function cardFields(card: ProductCard): ProductFields {
  return { name: card.name, article: card.article ?? '', barcode: card.primaryBarcode ?? '' }
}
